import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';

import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import './header.css'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/Inbox';
import Home from '@material-ui/icons/Home';
import Build from '@material-ui/icons/Build';
import FormatListNumbered from '@material-ui/icons/FormatListNumbered';
import Info from '@material-ui/icons/Info';
import ContactSupport from '@material-ui/icons/ContactSupport';
import SupervisedUserCircle from '@material-ui/icons/SupervisedUserCircle';
import Cancel from '@material-ui/icons/Cancel';






const styles = {
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginLeft: -18,
        marginRight: 10,
    },
};

class Header1 extends Component {
    constructor(props) {
        super(props)
        this.state = {
            scrolling: false,
            openDrawer: false
        }
    }
    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    handleScroll = (event) => {
        if (window.scrollY > 100 && this.state.scrolling !== true) {
            this.setState({ scrolling: true });
        }

        if (window.scrollY < 100 && this.state.scrolling !== false) {
            this.setState({ scrolling: false });
        }
    }
    openDrawerFunc = () => {
        this.setState({
            openDrawer: !this.state.openDrawer
        })
    }
    ScrollFunc = (type) => {
        if (type === 'home') {
            window.scrollTo(0, 0)
        }
        else if (type === 'services') {
            if (window.innerWidth < 500) {
                window.scrollTo(0, 200)
            }
            else {
                window.scrollTo(0, 600)

            }
        }
        else if (type === 'about') {
            if (window.innerWidth < 500) {
                window.scrollTo(0, 1400)
            }
            else {
                window.scrollTo(0, 1800)
            }
        }
        else if (type === 'skills') {
            if (window.innerWidth < 500) {
                window.scrollTo(0, 1800)
            }
            else {
                window.scrollTo(0, 2200)
            }
        }
        else if (type === 'contact') {
            if (window.innerWidth < 500) {
                window.scrollTo(0, 3810)
            }
            else {
                window.scrollTo(0, 3310)
            }

        }
        else if (type === 'testimonials') {
            if (window.innerWidth < 500) {
                window.scrollTo(0, 2400)
            }
            else {
                window.scrollTo(0, 2800)
            }

        }
        this.setState({
            openDrawer: false
        })
    }
    render() {
        return (
            <div className='HeaderMainDiv'>
                {
                    !this.state.openDrawer ? (

                        <AppBar position="fixed" className={`NavBarCustom ${this.state.scrolling ? 'Navbar' : null}`}>
                            <Toolbar variant="dense">
                                <IconButton color="inherit" aria-label="Menu" onClick={this.openDrawerFunc} >
                                    <MenuIcon />
                                </IconButton>

                            </Toolbar>
                        </AppBar>
                    ) : null
                }
                <div className={`w3-sidebar ${this.state.openDrawer ? 'w3-bar-block' : null}`} id="mySidebar">
                    <div className='DrawerMainDiv'>
                        <List component="nav">
                            <ListItem button onClick={this.ScrollFunc.bind(this, 'home')}>
                                <ListItemIcon >
                                    <Home />
                                </ListItemIcon>
                                <ListItemText primary="Home" />
                            </ListItem>
                            <ListItem button onClick={this.ScrollFunc.bind(this, 'services')}>
                                <ListItemIcon>
                                    <Build />
                                </ListItemIcon>
                                <ListItemText primary="Services" />
                            </ListItem>

                            <ListItem button onClick={this.ScrollFunc.bind(this, 'about')}>
                                <ListItemIcon>
                                    <Info />
                                </ListItemIcon>
                                <ListItemText primary="About" />
                            </ListItem>

                            <ListItem button onClick={this.ScrollFunc.bind(this, 'skills')}>
                                <ListItemIcon>
                                    <FormatListNumbered />
                                </ListItemIcon>
                                <ListItemText primary="Skills" />
                            </ListItem>
                            <ListItem button onClick={this.ScrollFunc.bind(this, 'testimonials')}>
                                <ListItemIcon>
                                    <SupervisedUserCircle />
                                </ListItemIcon>
                                <ListItemText primary="Testimonials" />
                            </ListItem>

                            <ListItem button onClick={this.ScrollFunc.bind(this, 'contact')}>
                                <ListItemIcon>
                                    <ContactSupport />
                                </ListItemIcon>
                                <ListItemText primary="Contact" />
                            </ListItem>
                            <ListItem button onClick={this.openDrawerFunc}>
                                <ListItemIcon>
                                    <Cancel />
                                </ListItemIcon>
                                <ListItemText primary="Cancel" />
                            </ListItem>


                        </List>

                    </div>
                </div>
                <div className='navbar'>
                    <div className='navbarChild1'>
                        <p>Muhazzib</p>
                    </div>
                    <div className='navbarChild2'>
                        <ul>
                            <li>Home</li>
                            <li onClick={this.ScrollFunc.bind(this, 'services')}>Services</li>
                            <li onClick={this.ScrollFunc.bind(this, 'about')}>About</li>
                            <li onClick={this.ScrollFunc.bind(this, 'skills')}>Skills</li>
                            <li onClick={this.ScrollFunc.bind(this, 'testimonials')}>Testimonials</li>

                            <li onClick={this.ScrollFunc.bind(this, 'contact')}>Contact</li>

                        </ul>
                    </div>
                </div>



                <div className='headerMainBody'>
                    <div className='headerMainBodyChild1'>

                        <p className='headerMainBodyParaOne'>Can you build the web app/mobile app of my dreams?</p>
                        <p className='headerMainBodyParaTwo'>YUP, I CAN DO THAT.</p>
                    </div>

                </div>
            </div>
        );
    }
}
Header1.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Header1);



// WEBPACK FOOTER //
// ./src/containers/header/header.js